import React from 'react';
import { isMobile, isMobileOnly } from 'react-device-detect';

const BreadcrumbsParticular = ({ name, certificated }) => {
	return (
		<div
			style={{
				display: 'flex',
				justifyContent: 'space-between',
				padding: isMobile ? 16 : certificated ? '9px 0px 24px 0px' : '16px 0px',
				paddingBottom: isMobileOnly ? 16 : 24
			}}>
			<div style={{ display: 'flex', alignItems: 'center' }}>
				<div
					style={{
						color: '#212121',
						fontSize: 16,
						fontWeight: 700
					}}>
					{name}
				</div>
			</div>
		</div>
	);
};
export default BreadcrumbsParticular;
